<div *ngIf="irisModalRef?.config?.data?.isOpened == true">
    <h2>{{irisModalRef?.config?.data?.titleText}}</h2>
    <div>
      {{irisModalRef?.config?.data?.bodyText}}
    </div>
    <div fxLayout="row" fxLayoutAlign.gt-xs="end center" fxLayoutAlign.lt-sm="center center" class="button-row">
      <iris-button (click)="irisModalRef.close(true)">OK</iris-button>
    </div>
</div>
